import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { useLocale } from '$contexts/locale.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ArticleCopyButton = ({
    modules = []
}) => {
    const { translate: t } = useLocale();

    const [copied, setCopied] = useState(false);

    const resetCopied = () => {
        setCopied(false);
    };

    const copyToClipboard = async () => {
        clearTimeout(resetCopied);

        await navigator.clipboard.writeText(modules?.map((module) => {
            if (module?.__typename === 'BvaPressModuleText') {
                return documentToPlainTextString(module.body?.json, '\n\n');
            }

            return null;
        }).filter((v) => v && v.length > 0).join('\n\n'));

        setCopied(true);

        setTimeout(resetCopied, 5000);
    };

    return (
        <button
            className='inline-block bg-orange text-white rounded mr-10 type-style-7 px-20 py-15'
            onClick={copyToClipboard}
            type='button'>
            {copied ? t('Copied') : t('Copy Text')}
        </button>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ArticleCopyButton.propTypes = {
    modules: PropTypes.array,
};

export default ArticleCopyButton;
